var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cell-container"},[_c('img',{attrs:{"src":_vm.imgPath,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }